module.exports = __webpack_public_path__ + "static/media/XXIIIh.263d7678.png";